module.exports = __webpack_public_path__ + "static/absolute-7fabe3827dd53557811be9dd1b278990.jpg";